export interface CampaignFeatureToggle {
	supportedCurrencies: string[];
	referral: { enabled: boolean; comingSoonLabel?: string; visible?: boolean };
	quests: { enabled: boolean; comingSoonLabel?: string; visible?: boolean };
	weeklyRace: { visible: boolean };
	giveaway: { enabled: boolean; comingSoonLabel?: string; visible?: boolean };
	dailyStreak: { enabled: boolean };
	vip: { enabled: boolean; comingSoonLabel?: string; visible?: boolean };
	campaignWalletEnabled: boolean;
}

export interface CampaignBonusNft {
	nameIncludes: string;
	multiplier: number;
}

export type BonusMultiplierCombinationStrategy = 'max' | 'multiply';

export interface CampaignTicketingConfig {
	apiPath: string;
	wageringCoinSymbol: string;
	firstTicketThreshold: number;
	additionalTicketStep: number;
	baseMultiplier: number;
	bonusNfts: CampaignBonusNft[];
	bonusCombinationStrategy?: BonusMultiplierCombinationStrategy;
}

export interface CampaignPromoButtonConfig {
	id: string;
	label: string;
	to?: string;
}

export type CampaignLifecycleState = 'disabled' | 'live' | 'results';

export interface CampaignConfig {
	id: string;
	slug: string;
	name: string;
	timeframe: { start: string; end: string };
	state: CampaignLifecycleState;
	ticketing: CampaignTicketingConfig;
	features: CampaignFeatureToggle;
	campaignResultsAvailable?: boolean;
	promoButton?: CampaignPromoButtonConfig;
}

const CAMPAIGN_STATE = resolveCampaignState();
const isCampaignLive = CAMPAIGN_STATE === 'live';
const isCampaignInResults = CAMPAIGN_STATE === 'results';

const CAMPAIGN_FEATURES: CampaignFeatureToggle = {
	supportedCurrencies: ['SUI'],
	referral: { enabled: false, comingSoonLabel: 'Soon', visible: false },
	quests: { enabled: false, comingSoonLabel: 'Soon', visible: true },
	weeklyRace: { visible: false },
	giveaway: { visible: false, enabled: false, comingSoonLabel: 'Soon' },
	dailyStreak: { enabled: false },
	vip: { enabled: false, comingSoonLabel: 'Soon', visible: false },
	campaignWalletEnabled: isCampaignLive,
};

const CAMPAIGN_RESULTS_AVAILABLE = isCampaignInResults;

const LIVE_PROMO_BUTTON: CampaignPromoButtonConfig = {
	id: 'sidebar.slush-wallet-welcome',
	label: '$5000 to win!',
};

const RESULTS_PROMO_BUTTON: CampaignPromoButtonConfig = {
	id: 'sidebar.slush-wallet-results',
	label: 'Campaign Results!',
	to: '/slush-wallet-campaign',
};

export const CAMPAIGN_CFG: CampaignConfig = {
	id: 'slush-wallet-campaign',
	slug: 'slush-wallet',
	name: 'Slush Wallet Campaign',
	state: CAMPAIGN_STATE,
	timeframe: {
		start: '2025-11-24T17:15:00.000Z',
		end: '2025-12-01T17:15:00.000Z',
	},
	ticketing: {
		apiPath: '/campaigns/slush-wallet/tickets',
		wageringCoinSymbol: 'SUI',
		firstTicketThreshold: 5,
		additionalTicketStep: 2,
		baseMultiplier: 1,
		bonusCombinationStrategy: 'multiply',
		bonusNfts: [
			{
				nameIncludes: 'Cane',
				multiplier: 2,
			},
			{
				nameIncludes: 'Slush',
				multiplier: 1.5,
			},
		],
	},
	features: CAMPAIGN_FEATURES,
	campaignResultsAvailable: CAMPAIGN_RESULTS_AVAILABLE,
	promoButton: CAMPAIGN_FEATURES.campaignWalletEnabled ? LIVE_PROMO_BUTTON : CAMPAIGN_RESULTS_AVAILABLE ? RESULTS_PROMO_BUTTON : undefined,
};

function resolveCampaignState(): CampaignLifecycleState {
	return 'disabled';
}
